var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 2H5.33333V5.33333H2V2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.33333 2H9.66666V5.33333H6.33333V2Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 2H10.6667V5.33333H14V2Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M2 6.33333H5.33333V9.66666H2V6.33333Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.66666 6.33333H6.33333V9.66666H9.66666V6.33333Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6667 6.33333H14V9.66666H10.6667V6.33333Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.33333 10.6667H2V14H5.33333V10.6667Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.33333 10.6667H9.66666V14H6.33333V10.6667Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M14 10.6667H10.6667V14H14V10.6667Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export default ForwardRef;